import React, {useEffect, useState} from 'react';
import {ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";

import Spinner from "reactjs-simple-spinner";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));


const Commissions = (props) => {

    const classes = useStyles();

    const [loading, setLoading] = useState(true);
    const [initiate, setInitiate] = useState(false);

    const stopLoading = () => {
        setLoading(false)
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setInitiate(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setInitiate(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }


        setTimeout(stopLoading, 3000);
    }, [])



    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            Commissions
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="col-lg-12">
                                    {/*    tabs*/}
                                    <div className={classes.root}>
                                        <section className="py-1">
                                            <div className="ml-5 mt-1">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row mt-5 p-2 mb-0">
                                                            <div className="col-md-5 mr-1 p-5 mt-md-0" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/accident-commissions'}>
                                                                    <div className="move-on-hover">
                                                                        <h3 className="mb-0">
                                                                            <i className="fa-solid fa-car-burst fa-2x"></i>
                                                                            &nbsp;Accident Commissions</h3>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-5 mr-1 p-5 mt-md-0" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/comprehensive-commissions'}>
                                                                    <div className="move-on-hover">
                                                                        <h3 className="mb-0">
                                                                            <i className="fa-solid fa-hands-holding-child fa-2x"></i>
                                                                            &nbsp;Comprehensive Commissions</h3>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-5 mr-1 p-5 mt-md-2" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/pfuma-commissions'}>
                                                                    <div className="move-on-hover">
                                                                        <h3 className="mb-0">
                                                                            <i className="fa-solid fa-cow fa-2x"></i>
                                                                            &nbsp;Pfuma / Inotho Commissions</h3>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-5 mr-1 p-5 mt-md-2" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%',
                                                            }}>
                                                                <a href={'/funeral-commissions'}>
                                                                    <div className="move-on-hover">
                                                                        <h3 className="mb-0">
                                                                            <i className="fa-solid fa-truck-medical fa2x"></i>
                                                                            &nbsp;Funeral Commissions
                                                                        </h3>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-5 p-5 mt-md-2" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/savings-commissions'}>
                                                                    <div className="move-on-hover">
                                                                        <h3 className="mb-0">
                                                                            <i className="fa-solid fa-piggy-bank fa-2x"></i>
                                                                            &nbsp;Savings Commissions</h3>
                                                                    </div>
                                                                </a>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    {/*    end tabs*/}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )

}

export default Commissions
